import ElementPlus from 'element-plus'
// import { createI18n } from 'vue-i18n'
import 'element-plus/theme-chalk/index.css'
import localeZH from 'element-plus/es/locale/lang/zh-cn'
// import localeEN from 'element-plus/lib/locale/lang/en'
// import messages from '../utils/i18n'
// console.log(msg)

// const messages = {
//   [localeEN.name]: {
//     el: localeEN.el,
//     i18n: msg.en.i18n,
//   },
//   [localeZH.name]: {
//     el: localeZH.el,
//     i18n: msg.zh.i18n,
//   },
// }

// const i18n = createI18n({
//   locale: localeZH.name,
//   fallbackLocale: localeEN.name,
//   messages,
// })

export default (app) => {
  app.use(ElementPlus, { locale:localeZH })
  // app.use(i18n)
}
